const Theme = {
  logo_image_url: 'centech.png',
}

export default Theme
